<template>
	<div class="page">
		<header class="lmy-header lmy-header-user">
			个人中心
	        <!-- <i class="iconfont icon-yuyin" @click="routetokPage('/')"></i> -->
			<span class="back-home" @click="routetokPage('/')">返回首页</span> 
	    </header>
		<div class="user-box">
			<div class="user-info">
				<div class="avatar">
					<img src="./../../assets/img/userDefaultImg.png" v-if="!userInfo.Avater" alt=""  @click="toLogin()">
					<img :src="userInfo.Avater" v-if="userInfo.Avater">
				</div>
				<div class="user" v-if="userInfo.CustomerNO">
					<p class="name">
						{{userInfo.Customer}}
						<span class="tag" v-if="!userInfo.IsParterner">会员</span>
						<span class="tag" v-if="userInfo.IsParterner">合伙人</span>
					</p>
					<p class="number">编号：<span>{{userInfo.CustomerNO}}</span> </p>
				</div>
				<div v-else class="user" @click="toLogin()">
					<p>立即登陆</p>
				</div>

			</div>

			<div class="user-account module-box" v-if="userInfo.CustomerNO" @click="routetokPage('/withdraw')">
				<p class="module-title">我的钱包</p>
				<p class="withdraw"  @click="routetokPage('/withdraw')">去提现 <i class="iconfont icon-more"></i></p>
				<ul class="module-content">
					<li class="ops">
						<div class="title">余额(元) </div>
						<div class="price">{{accountInfo.AvaliableTotalAmount|numberFloat}}</div>
					</li>
					<li class="ops">
						<div class="title">累计提现(元)  </div>
						<div class="price">{{(accountInfo.TotalWithdrawed)|numberFloat}}</div>
					</li>
				</ul>
			</div>
			<div class="user-order module-box">
				<p class="module-title">订单中心</p>
				<ul class="module-content">
					<li class="ops" @click="routetokPage('/myOrder?type=my')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-dingdan1"></use>
						</svg>
						<span>我的订单</span>
					</li>
					<li class="ops" @click="routetokPage('/meetingList')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-huiyidingdan"></use>
						</svg>
						<span>会议订单</span>
					</li>
					<li class="ops" @click="routetokPage('/cashBack')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-fanyongdingdan"></use>
						</svg>
						<span>返佣订单</span>
					</li>
					<li class="ops" @click="routetokPage('/list')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-wodefapiao"></use>
						</svg>
						<span>我的发票</span>
					</li>
				</ul>
			</div>

			<!-- <div class="user-tool module-box">
				<p class="module-title">我的工具</p>
				<ul class="module-content">
					<li class="ops" @click="routetokPage('/withdraw')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-yongjintixian"></use>
						</svg>
						<span>佣金提现</span>
					</li>
					<li class="ops" @click="routetokPage('/myQr')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-fazhanxiaji"></use>
						</svg>
						<span>发展下级</span>
					</li>
					<li class="ops" @click="routetokPage('/myMember')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-wodexiaji"></use>
						</svg>
						<span>我的下级</span>
					</li>
				</ul>
			</div> -->

			<div class="user-tool module-box">
				<p class="module-title">我的工具</p>
				<ul class="module-content">
					<li class="ops" @click="routetokPage('/collect')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-wodeshoucang"></use>
						</svg>
						<span>我的收藏</span>
					</li>
					<li class="ops" @click="routetokPage('/history')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-liulanlishi"></use>
						</svg>
						<span>浏览历史</span>
					</li>
					<li class="ops" @click="routetokPage('/resetPhone')">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-genggaixinxi"></use>
						</svg>
						<span>更改信息</span>
					</li>
					<li class="ops" @click="openContact">
						<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-lianxikefu"></use>
						</svg>
						<span>联系客服</span>
					</li>
				</ul>
			</div>
			<div class="lmy-banner min-banner">
                <Swipe :auto="5000">
                    <SwipeItem v-for="img in bannerPresaleList" :key="img.Name" :auto="5000"  >
                        <img :src="('/'+img.Img)|replaceImgSrc(100)"  class="swipe-imgs" style="width:100%;height:1.76rem"   @click="toPresaleDetail(img.ProductID,img)"  />
                    </SwipeItem>
               
                </Swipe>
            </div>

			<div class="grayBtn" @click="logout" v-if="userInfo.CustomerNO">退出登录</div>
		</div>
	</div>

</template>
<script>
    const { Swipe, SwipeItem } = require('vue-swipe');
	export default{
		name:'user',
		data(){
			return{
				userInfo:this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'',
				showContact:false,
				isUserQrShow:false,
				userQr:'',
				accountInfo:'',
        bannerPresaleList:[],
			}
		},
		components:{
			SwipeItem,
            Swipe,
		},
		methods:{
			toLogin(){
				this.$router.push({ path: '/login'});
			},
			//获取抢购广告轮播图
            getBannerSmallImgList(){
                var that=this;
                that.getRequest({
                    url: that.Api.bannerPresale
                }).then(res => {
                    if(res&&res.IsSuccess){
                        that.bannerPresaleList=res.Result;
                    }
                });

			},
			// 海报跳转
			toPresaleDetail(id,img){
                if(img.Url){
                    // window.location.href=img.Url;
                    // return;
					if(img.BannerType==1){
						var hotelId=img.ProductID;
						var hotelFrom=img.ProductID>=5000000?0:1;
						var obj={
							ID:hotelId,
						}
						this.routeToDetails(obj,hotelFrom)
					}else if(img.BannerType==2){
						this.$router.push("/packageDetails?id="+img.ProductID+"&price=''");
					}else if(img.BannerType==3){
					this.$router.push('/presaleDetails?id='+img.ProductID);
					}else {
						window.location.href=img.Url;
					}
                }
                
               
            },
			logout(){
				localStorage.clear();
				this.setHttpHeaders('');
				this.$root.myImg=''
				this.$router.push('/anonymLogin');
				// this.$router.push('/logout')
			},
			initData(){
 		 		var that=this;
 		 		var param={
					Page:0,
					PageSize:10,
					WithdrawID:'',
				}
				that.postRequest({
					url:that.Api.getBills,
					params:param
				}).then(res => {
					this.loading=false;
					if (res&&res.IsSuccess) {
				        that.accountInfo =res.Result;
				    }
				});
 		 	}

		},
		mounted(){
			if(!this.userInfo){
				this.$router.push('/anonymLogin')
			}
			this.getBannerSmallImgList()
			this.initData();
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/usr/user.vue